import normalize from 'json-api-normalizer';

export default class User {
	static from (jsonapi) {
		let key = 'users'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = User.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return User.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;
		return new User ( Object.assign({}, {id: id}, attributes) );
	}

	constructor ({ id, login, provinceId, provinceName, clientSourceId, clientSourceName, firstName, lastName, nicknameForum, email, lastLogin, passwordChangedAt, sharedFile }) {

		this.id         = id ? id : -1;
		this.login 		= login ? login : '';
		this.province_id = provinceId ? provinceId : null;
		this.province_name = provinceName ? provinceName : null;
		this.client_source_id = clientSourceId ? clientSourceId : null;
		this.client_source_name = clientSourceName ? clientSourceName : null;
		this.first_name = firstName ? firstName : '';
		this.last_name  = lastName ? lastName : '';
		this.nickname_forum	= nicknameForum ? nicknameForum : null;
		this.email		= email ? email : '';
		this.last_login = lastLogin ? lastLogin : null;
		this.password_changed_at = passwordChangedAt ? passwordChangedAt : null;
		this.shared_file		 = (sharedFile != null) ? sharedFile : null;
	}

	displayName() {
		return this.first_name + ((this.last_name.length > 0) ? ( ' ' + this.last_name.substr(0, 1) + '.' ) : '');
	}

	toUser () {
		return new User ({ id: this.id, login: this.login, provinceId: this.province_id, provinceName: this.province_name, firstName: this.first_name, lastName: this.last_name });
	}

	toJSONapi () {
	  let attributes = Object.assign({}, this);
	  delete attributes.id;

	  attributes.email = attributes.email.toLowerCase().trim();

	  return {data: {type: "users", id: this.id, attributes: attributes}};
	}

}
